var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6736_1745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9548 7.0293C10.5043 7.47975 9.62471 8.6715 9.07849 11.4381C8.58192 13.9528 8.323 15.3113 8.19531 15.9958C10.1922 15.9497 12.0082 15.1729 13.3844 13.9173C13.1077 11.0798 12.1643 8.81338 10.9583 7.0293H10.9548Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3987 5.84962C13.0757 5.72548 12.0861 6.22204 11.625 6.51643C12.8132 8.25795 13.7638 10.4357 14.1362 13.1314C15.2996 11.741 16.0019 9.95336 16.0019 7.99903C16.0019 7.2932 15.9096 6.60865 15.7394 5.95602C15.4273 5.94184 14.9981 5.90637 14.4022 5.84962H14.3987Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26195 11.2755C8.87202 8.18968 9.89707 6.86669 10.4646 6.34175C10.0851 5.84519 9.68425 5.38764 9.27636 4.97266C4.9669 7.81726 3.23956 12.7297 2.82812 14.1023C4.06599 15.1522 5.63016 15.8332 7.34686 15.9715C7.46745 15.326 7.72637 13.9534 8.25486 11.2755H8.26195Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0075 4.5194C10.3941 4.92374 10.7736 5.36355 11.1354 5.83884C11.678 5.47351 12.8521 4.86699 14.4765 5.02305C14.9092 5.06562 15.2249 5.09045 15.4555 5.10463C15.0972 4.18599 14.5758 3.34538 13.9232 2.62891C13.3486 2.75659 12.1994 3.19286 10.0039 4.52294L10.0075 4.5194Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46094 3.09679C8.77306 3.34862 9.08519 3.62173 9.39377 3.91257C11.0324 2.9088 12.3022 2.25972 13.235 1.95114C12.4831 1.29852 11.607 0.78422 10.6458 0.447266C10.284 1.40492 9.35475 2.35194 8.46094 3.09324V3.09679Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78034 2.57504C8.51454 1.97916 9.50058 1.06761 9.84462 0.21636C9.25229 0.0780315 8.63514 0 8.00024 0C6.80494 0 5.66994 0.266016 4.64844 0.734205C5.42166 1.08535 6.55666 1.67413 7.78034 2.57149V2.57504Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66504 4.37658C8.3671 4.10347 8.07271 3.85164 7.77832 3.62109C7.21436 3.99352 6.72135 4.09638 5.85945 4.27727C5.30614 4.39431 4.54711 4.55392 3.46176 4.85186C0.766127 5.60026 0.092219 7.38079 0.0638439 7.45882C0.0532033 7.49075 0.031922 7.52267 0.0141875 7.55104C0.00709377 7.70001 0 7.84898 0 8.0015C0 10.1154 0.81933 12.0343 2.15651 13.4637C2.75948 11.6371 4.58258 7.15379 8.66149 4.38013L8.66504 4.37658Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23909 4.04973C4.34572 3.74469 5.11894 3.58154 5.68289 3.46094C6.33197 3.32616 6.70439 3.24458 7.04844 3.07433C5.59067 2.04219 4.30315 1.47469 3.71437 1.24414C2.12891 2.255 0.92297 3.80499 0.355469 5.63873C0.961986 5.0464 1.88063 4.4257 3.23909 4.04973Z",
    fill: "#D8D8D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6736_1745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.9965,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsIcon);
export default __webpack_public_path__ + "static/media/SportsIcon.6c8f2bd4d932c87e302a8b59e270e074.svg";
export { ForwardRef as ReactComponent };